'use client';

import { PostHogReady, usePostHogInit } from '@/lib/analytics/posthog-init';
import { ApiProvider } from '@/lib/api/provider';
import { QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { type ReactNode } from 'react';
import { AdminVisibilityProvider } from './contexts/admin-visibility-context';
import { getQueryClient } from './query-client';

export function Providers({ children }: { children: ReactNode }) {
  const posthogReady = usePostHogInit();
  const queryClient = getQueryClient();

  return (
    <PostHogReady value={posthogReady}>
      <PostHogProvider client={posthog}>
        <ApiProvider>
          <QueryClientProvider client={queryClient}>
            <AdminVisibilityProvider>{children}</AdminVisibilityProvider>
          </QueryClientProvider>
        </ApiProvider>
      </PostHogProvider>
    </PostHogReady>
  );
}
